module.exports = __webpack_public_path__ + "img/logo.09c085a0.png";